import { Loader2 } from 'lucide-react';

/**
 * The whole-page loading state.
 *
 * `role="status"` and a real label rather than a bare spinner: someone using a
 * screen reader gets told the page is working, not silence. The label is
 * visible too — "Signing you in" tells you what is happening, a rotating circle
 * does not.
 */
export function FullPageSpinner({ label = 'Loading' }: { label?: string }) {
  return (
    <div
      role="status"
      aria-live="polite"
      className="flex min-h-screen flex-col items-center justify-center gap-3 bg-ink-50"
    >
      <Loader2 aria-hidden="true" className="size-6 animate-spin text-bark-700" />
      <p className="text-body text-ink-500">{label}…</p>
    </div>
  );
}
